// https://vuex.vuejs.org/en/state.html
let appElement = document.getElementById('app');

export default {
    eventCard: {},
    hallPlan: {},
    performanceID: appElement.dataset.performance,
    img: appElement.dataset.img
}
